
					const modules = import.meta.glob([
  "/mock/basp/queryMenus.mock.ts",
  "/mock/basp/queryMenusTree.mock.ts",
  "/mock/basp/queryRoles.mock.ts",
  "/mock/menu/getMenus.mock.ts",
  "/mock/user/getUserInfo.mock.ts",
  "/mock/utils.ts"
], { eager: true });
					const fakeModuleList = Object.keys(modules).reduce((list, key) => {
						const module = modules[key] ?? {};
						if (module.default) {
							for (const moduleKey of Object.keys(module)) {
								const mod = modules[key][moduleKey] ?? [];
								const modList = Array.isArray(mod) ? [...mod] : [mod];
								return [...list, ...modList];
							}
						} else {
							return list;
						}
					}, []);
					window.__VITE__PLUGIN__FAKE__SERVER__.fakeModuleList = fakeModuleList;
				